import React from 'react';
import { Typography } from '@mui/material';

import Section from '../../../layout/Section';
import InvestmentSlider from '../../../common/inputs/InvestmentSlider';
import { formatCurrency } from '../../../../utils/formatters';
import { fonts, colors } from '../../../../styles/theme';

interface InvestmentSectionProps {
  /** Gesamtinvestition (CAPEX Summe) in EUR */
  gesamtinvestition: number;
  /** Eigenkapitalquote in Prozent (z.B. 20) */
  eigenkapitalquote: number | undefined;
  /** Eigenkapital in EUR (berechnet: Gesamtinvestition * EK-Quote) */
  eigenkapital: number;
  /** Fremdkapital in EUR (berechnet: Gesamtinvestition * FK-Quote) */
  fremdkapital: number;
  /** Summe aller Darlehenshöhen in EUR (optional) */
  summeDarlehen?: number;
  /** Kann der Benutzer bearbeiten? */
  canEdit: boolean;
  /** Handler für Änderung der Eigenkapitalquote */
  onEigenkapitalquoteChange: (value: number) => void;
}

/**
 * Investitionssektion - zeigt Gesamtinvestition und EK/FK-Aufteilung
 * 
 * Verwendet einen interaktiven Slider zur Anpassung der EK/FK-Quote.
 * Zeigt Gesamtinvestition, beide Quoten und absolute Beträge.
 */
const InvestmentSection: React.FC<InvestmentSectionProps> = ({
  gesamtinvestition,
  eigenkapitalquote,
  eigenkapital,
  fremdkapital,
  canEdit,
  onEigenkapitalquoteChange,
}) => {
  return (
    <Section
      title="Investition"
      actionsPosition="center"
      actions={
        <Typography sx={{
          fontWeight: fonts.weights.semiBold,
          fontSize: '1rem',
          color: colors.brand.teal400,
          fontFamily: fonts.monospace
        }}>
          {formatCurrency(gesamtinvestition)}
        </Typography>
      }
    >
      <InvestmentSlider
        eigenkapitalquote={eigenkapitalquote ?? 20}
        gesamtinvestition={gesamtinvestition}
        eigenkapital={eigenkapital}
        fremdkapital={fremdkapital}
        onChange={onEigenkapitalquoteChange}
        disabled={!canEdit}
      />
    </Section>
  );
};

export default InvestmentSection;
